import { render, staticRenderFns } from "./RuleDialogComponent.vue?vue&type=template&id=1b94463e&scoped=true"
import script from "./RuleDialogComponent.vue?vue&type=script&lang=js"
export * from "./RuleDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94463e",
  null
  
)

export default component.exports